import { PropTypes } from 'prop-types';
import React from 'react';

import CourierBird from '../../assets/svg/courier-bird.svg';
import {
  podcastTextMap,
  podcastThemeNamesMap,
} from '../Article/ArticlePodcast/Mappings';

const PodcastHeader = ({ podcastTheme }) => {
  return (
    <div className="podcast-header">
      <div
        className={`podcast-header__title ${podcastThemeNamesMap[podcastTheme].title}`}
      >
        <div className="podcast-header__logoContainer">
          <CourierBird />
          <h1
            className={`podcast-header__name--${podcastTextMap[
              podcastTheme
            ].title.toLowerCase()}`}
          >
            {podcastTextMap[podcastTheme].title}
          </h1>
        </div>
        <h6
          className={`podcast-header__subhead ${podcastThemeNamesMap[podcastTheme].subheader}`}
        >
          {podcastTextMap[podcastTheme].subhead}
        </h6>
      </div>
    </div>
  );
};

PodcastHeader.propTypes = {
  podcastTheme: PropTypes.string,
};

export default PodcastHeader;
